import Vue from 'vue'
import Vuex from 'vuex'
import auth, { authInit } from './auth'
import app from './app'
import timesheet from './timesheet'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    auth,
    app,
    timesheet
  }
})

authInit(store)

export default store